<template>
  <div v-if="loadComponent">
    <v-row>
      <v-col cols="12" xs="12" sm="4" md="4" class="py-0 my-0">
        <v-select
          label="Email Type"
          class="py-0 my-0"
          :items="emailTypes"
          item-text="description"
          item-value="code"
          v-model="emailFormat.emailType"
        ></v-select>
      </v-col>
      <v-col cols="12" xs="12" sm="4" md="2" class="py-0 my-0">
        <v-btn @click.stop="dialog = true" icon>
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" class="py-0 my-0">
        <v-text-field
          label="Subject"
          class="py-0 my-0"
          v-model="emailFormat.subject"
        ></v-text-field>
      </v-col>
    </v-row>
    <quill-editor
      :options="editorOption"
      v-model="emailFormat.message"
    ></quill-editor>
    <v-row>
      <v-col cols="12" xs="12" sm="12" md="12" class="py-0 my-0">
        <v-checkbox
          label="Is Active"
          v-model="emailFormat.isActive"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-btn
          color="success"
          :loading="isSaving"
          @click.stop="save"
          v-if="userAccess.update >= 1 || userAccess.add >= 1"
          >Save</v-btn
        >
        &nbsp;
        <v-btn :loading="isSaving" @click.stop="cancel">Cancel</v-btn>
      </v-col>
      <v-col>
        <v-card>
          <v-container>
            <p>
              These are the following fields that you can use for the Email. To
              use these field. Kindly Input and use the curly brackets eg.
              <b>{ApplicantName}</b>
            </p>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Field Name</th>
                    <th class="text-left">Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in items" :key="item.field">
                    <td style="width: 200px;">{{ item.field }}</td>
                    <td>{{ item.value }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-data-table :items="list" :headers="headers">
      <template v-slot:item.actions="{ item }">
        <v-btn @click.stop="edit(item)" text icon>
          <v-icon color="primary">mdi-pencil</v-icon>
        </v-btn>
        <v-btn @click.stop="deleteItem(item)" text icon>
          <v-icon color="error">mdi-delete</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.message="{ item }">
        <span v-html="item.message">{{ item.message }}</span>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" width="900" persistent>
      <v-card>
        <v-card-title>
          <span>New Email Type</span>
        </v-card-title>
        <v-card-text>
          <email-type></email-type>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click.stop="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
const API_ENDPOINT = "/api/emailFormat";
import isEmpty from "lodash/isEmpty";
import userAccessMixin from "../../../../mixins/userAccessMixin";
import EmailType from "./other-notif/Index.vue";
export default {
  components: {
    quillEditor,
    EmailType,
  },
  mixins: [userAccessMixin],
  data: () => ({
    content: "",
    editorOption: {
      /* quill options */
    },
    isSaving: false,
    items: [
      {
        field: "EmpCode",
        value: "{EmpCode}",
      },
      {
        field: "Employee Name",
        value: "{EmployeeName}",
      },
    ],
    transType: "OTHN",
    emailFormat: {},
    list: [],
    headers: [
      { text: "", value: "actions", sortable: false },
      { text: "Email Type", value: "emailTypeDesc", sortable: false },
      { text: "Subject", value: "subject", sortable: false },
      { text: "Message", value: "message", sortable: false },
      { text: "Active", value: "isActive", sortable: false },
    ],
    dialog: false,
    emailTypes: [],
  }),
  created() {
    this.getEmailFormat(this.transType);
    this.getEmailTypes();

    this.getUserAccessRights("EMAILFRMT");
  },
  methods: {
    getEmailFormat(transType) {
      this.$axios
        .get(`${API_ENDPOINT}/list/${transType}`)
        .then(({ data }) => {
          this.list = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    save() {
      this.isSaving = true;
      this.emailFormat.transType = this.transType;
      this.$axios
        .post(`${API_ENDPOINT}`, this.emailFormat)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.cancel();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    getEmailTypes() {
      this.$axios
        .get(`/api/emailType`)
        .then(({ data }) => {
          if (!isEmpty(data)) {
            this.emailTypes = data;
            this.$set(this.emailFormat, "emailType", data[0].code);
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    edit(item) {
      this.emailFormat = Object.assign({}, item);
    },
    deleteItem(item) {
      console.log(item);
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete",
      }).then((res) => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.id}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.cancel();
              this.$router.push({
                path: this.$route.fullPath,
                query: {
                  emailTypes: Math.floor(Math.random() * 0x10000).toString(16),
                },
              });
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    cancel() {
      this.emailFormat = {};
      this.getEmailTypes();
      this.getEmailFormat(this.transType);
    },
  },
  watch: {
    "$route.query.emailTypes"(oldVal, newVal) {
      if (oldVal !== newVal) {
        this.getEmailTypes();
      }
    },
  },
};
</script>
